import {
  registerBlockType,
  InspectorControls
} from "@wordpress/blocks";

const { URLInputButton, RichText } = wp.editor;

// Just a way to wrap elements without producing any wrapper markup
import {
    Fragment,
    RawHTML
} from "@wordpress/element";

// Components contain several reusable React components
import {
    TextControl,
    ToggleControl
} from "@wordpress/components";

import { __ } from '@wordpress/i18n';

import "./style.scss";

registerBlockType("eelvnewsletter/post", {
  title: __("Newsletter Post Preview"),
  icon: "email",
  category: "common",
  attributes: {
        post_id: {
            type: "integer",
        },
        hasShareButtons: {
          type: "boolean",
          default: false
        },
        title: {
            type: "string",
        },
        url: {
            type: "string",
        },
        imageUrl: {
            type: "string",
        },
        content: {
            type: "string",
        },
        layout: {
            type: "string",
        }
  },

  edit({ className, attributes, setAttributes, isSelected }) {
    const { post_id, hasShareButtons, title, url, imageUrl, content } = attributes;

    const toggleShareButtons = () => setAttributes({ hasShareButtons: ! hasShareButtons });

    function generateContent (url, post_part){
      if(post_part){
        const skin_id = jQuery('#eelv-newsletter-skins').data('id');
        url = post_part.url;
        wp.apiRequest( { path: '/wp/v2/posts/' + post_part.id } ).done((post) => {
          if(post && post.id){
            setAttributes({
              post_id: post.id,
              content: post.excerpt.rendered,
              title: post.title.rendered,
              url: post.link
            });
            if(post.featured_media){
              wp.apiRequest( { path: '/wp/v2/media/' + post.featured_media } ).done((media) => {
                if(media && media.id){
                  setAttributes({
                    imageUrl: media.media_details.sizes.thumbnail.source_url
                  });
                }
              });
            }
          }
          return true;
        });
      }
      setAttributes({url: url});
    }



    if(!post_id){
        return (
            <div className={className}>
              <URLInputButton
                  className="url"
                  value={url}
                  placeholder={__('URL')}
                  onChange={( url, post ) => generateContent(url, post)}
              />
            </div>
        );
    }
    return (
        <div className={className}>
        {!isSelected && (
          <div>
            <h3>{title}</h3>
            {content}
          </div>
        )}
        {isSelected && (
          <div>
            { imageUrl &&
                <img
                    src={imageUrl}
                />
            }
            <div className="post-texts">
                <TextControl
                    className="title"
                    value={title}
                    onChange={(title) => setAttributes({title})}
                    placeholder={__('Title')}
                />
                <RichText
                    className="content"
                    value={content}
                    onChange={(content) => setAttributes({content})}
                    placeholder={__('Content')}
                />
                <ToggleControl
                    label={ __( 'Share buttons' ) }
                    checked={ !! hasShareButtons }
                    className="share_buttons"
                    onChange={toggleShareButtons}
                  />
              </div>
          </div>
        )}
        </div>
    );
  },

  save() {
    return null;
  }
});



// WEBPACK FOOTER //
// ./blocks/post/index.js